import * as React from 'react';
import { SQUARE_METER_SIGN } from '../../../../constants/symbols';
import { RangeInput } from '../RangeInput';
import { SearchResultsTooltip } from '../SearchResultsTooltip';

interface IAreaDropdownProps {
  tooltipOpened: boolean;
  filterRef: React.RefObject<HTMLDivElement | null>;
  areaFrom?: number;
  areaTo?: number;
  onAreaFromChange: (value?: number) => void;
  onAreaToChange: (value?: number) => void;
}

export const AreaDropdown: React.FC<IAreaDropdownProps> = ({
  tooltipOpened,
  filterRef,
  areaFrom,
  areaTo,
  onAreaFromChange,
  onAreaToChange,
}) => {
  return (
    <SearchResultsTooltip open={tooltipOpened} placement="right" hostElement={filterRef.current}>
      <div>
        <RangeInput
          min={0}
          max={99999}
          joined={false}
          postfix={SQUARE_METER_SIGN}
          valueMin={areaFrom}
          valueMax={areaTo}
          onChangeMin={onAreaFromChange}
          onChangeMax={onAreaToChange}
        />
      </div>
    </SearchResultsTooltip>
  );
};
